import { literal, struct } from 'io-ts/lib/Decoder';

import { DimensionLine } from '../scale/DimensionLine';

/**
 * UI -> BE: manually entered external dimensions tied to the client-derived
 * envelope of the frames selected as external.
 *
 * This is distinct from the legacy External Dimensions step confirmation: its
 * line geometry comes from the selected frames, not from one OCR-linked plan
 * dimension. The protobuf adapter intentionally maps both messages to Brain
 * Engine's existing ExternalDimensionsConfirmed wire shape.
 */
export const ExternalFrameDimensionsConfirmed = struct({
	type: literal('external-frame-dimensions-confirmed'),
	xDimension: DimensionLine,
	yDimension: DimensionLine,
});
